// Owner in P2: piece 19 "Settings, Today objections, @core" (docs/FILE-OWNERSHIP.md).
// The feature's entry file (docs/CONTRACTS.md section 16): `/settings`, one lazy chunk. The single-key choice must hold on
// every screen, so its gate is installed here, with the entry, and not with the lazy screen.
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { Settings } from 'lucide-react'
import type { Feature } from '../feature.ts'
import { installSingleKeyGate } from './keysPref.ts'

installSingleKeyGate()

export const feature: Feature = {
  app: (parent) => [createRoute({ getParentRoute: () => parent, path: '/settings', component: lazyRouteComponent(() => import('./SettingsScreen.tsx')) })],
  nav: [{ to: '/settings', label: 'nav.settings', icon: Settings, group: 'system' }],
}
